import { createContext } from "react";

export const DateContext = createContext({
  startingDate: null,
  endingDate: null,
});
